export const PracticeInput = { extracting: false };
